import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

import { convertToFormData } from '../utils/helpers';
import { normalizeDateForServer } from '../utils/date';

export const fetchMessages = ({ chat_id, message_id, file_id, task_id, entity_key, limit = 15, before_date, after_date, before_id, after_id }) => {
    return AjaxService({
        method: 'get',
        url: `messages`,
        params: {
            chat_id,
            message_id,
            file_id,
            task_id,
            entity_key,
            limit,
            before_date: normalizeDateForServer(before_date),
            after_date: normalizeDateForServer(after_date),
            before_id,
            after_id
        }
    })
    .then(response => response.data);
}

export const sendMessage = ({ chat, thread, file, task, document, entity_key, text, type, url, files, nifty_files, doc_attachment }) => {
    return AjaxService({
        method: 'post',
        url: 'messages',
        data: convertToFormData({
            chat_id: chat,
            message_id: thread,
            file_id: file,
            task_id: task,
            doc_id: document,
            entity_key: entity_key,
            text: text || '',
            type,
            url,
            file: files ? files.filter(file => (file instanceof File) || file.uri) : undefined,
            'external_files': files ? files.filter(file => file.serviceType).map(({ serviceProps }) => serviceProps) : undefined,
            'nifty_files': nifty_files,
            doc_attachment
        })
    })
    .then(response => response.data.data)
    .catch(handleServerError);
}

export const fetchMessage = messageId => {
    return AjaxService({
        method: 'get',
        url: `messages/${messageId}`
    })
    .then(response => response.data);
}

export const updateMessage = (messageId, { text, files }) => {
    return AjaxService({
        method: 'put',
        url: `messages/${messageId}`,
        data: convertToFormData({
            text,
            file: files ? files.map(file => file.file) : undefined,
        })
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeMessage = messageId => {
    return AjaxService({
        method: 'delete',
        url: `messages/${messageId}`,
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const seeMessage = messageId => {
    return AjaxService({
        method: 'post',
        url: `messages/${messageId}/see`,
    })
    .then(response => response.data);
}

export const setMessageReaction = (messageId, reaction) => {
    return AjaxService({
        method: 'post',
        url: `messages/${messageId}/reactions`,
        data: { reaction }
    })
    .then(response => response.data);
}
